import { useIsEUDB } from '@ms/yammer-hooks/dist/eudb';
import { useIsSuiteHeaderAvailable } from '@ms/yammer-hooks/dist/suiteHeader';
import { LazyLoadOnIdle } from '@ms/yammer-libs-lazy';
import React, { FC } from 'react';

import MobileVivaAppBarPlaceholder from './MobileVivaAppBarPlaceholder';

const loader = () => import(/* webpackChunkName: "4-feat-vivaappbarmobile" */ './MobileVivaAppBar');

const LoadableMobileVivaAppBar: FC = () => {
  const isSuiteHeaderAvailable = useIsSuiteHeaderAvailable();
  const isEUDB = useIsEUDB();

  if (!isSuiteHeaderAvailable || isEUDB == null) {
    return <MobileVivaAppBarPlaceholder isEUDB={false} />;
  }

  return <LazyLoadOnIdle loader={loader} isEUDB={isEUDB} Placeholder={MobileVivaAppBarPlaceholder} />;
};

export default LoadableMobileVivaAppBar;
